/**
 * 船务后台管理端（独立前端）页面地址拼接。
 * 根地址由 `import.meta.env.VITE_SHIPPING_ADMIN_ORIGIN` 配置。
 */
export function getShippingAdminOrigin(): string {
    return String(import.meta.env.VITE_SHIPPING_ADMIN_ORIGIN ?? "").replace(/\/+$/, "");
}

/** @param relPath 不含前导 `/`，如 `shipManage/shipInfo/shipInfoDetail/123` */
export function buildShippingAdminPageUrl(relPath: string): string | null {
    const base = getShippingAdminOrigin();
    if (!base) return null;
    const path = relPath.replace(/^\/+/, "");
    return `${base}/${path}`;
}

export function openShippingAdminPage(relPath: string): boolean {
    const url = buildShippingAdminPageUrl(relPath);
    if (!url) return false;
    window.open(url, "_blank", "noopener,noreferrer");
    return true;
}

/** 打开船舶详情页 */
export function openShippingShipDetail(shipId: string | null | undefined): boolean {
    const id = String(shipId ?? "").trim();
    if (!id) return true;
    return openShippingAdminPage(`shipManage/shipInfo/shipInfoDetail/${encodeURIComponent(id)}`);
}

/** 打开船运单/船运需求详情页（优先船运单） */
export function openShippingTransportDetail(
    transportOrderShipId: string | null | undefined,
    requirementPlatId: string | null | undefined
): boolean {
    const shipOrderId = String(transportOrderShipId ?? "").trim();
    if (shipOrderId) {
        return openShippingAdminPage(
            `waybillManagement/shipWaybillManagement/detail/${encodeURIComponent(shipOrderId)}`
        );
    }
    const requirementId = String(requirementPlatId ?? "").trim();
    if (requirementId) {
        return openShippingAdminPage(`waybillManagement/shipDemandManagement/detail/${encodeURIComponent(requirementId)}`);
    }
    return true;
}
